// src/components/one-key-banner/one-key-banner.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      description\n      id\n      title\n      token\n      theme\n    }\n    action {\n      ...ButtonLinkActionFragment\n    }\n  }\n\n  fragment ButtonLinkActionFragment on UILinkAction {\n    resource {\n      ...HttpURIFragment\n    }\n    target\n    useRelativePath\n  }\n\n  fragment HttpURIFragment on HttpURI {\n    relativePath\n    value\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    stylizedText: text\n    theme\n    weight\n    textSize: size\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    target\n    resource {\n      __typename\n      value\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    __typename\n    action {\n      ...UILinkActionFragment\n    }\n    disabled\n    text\n    size\n  }\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextInlineContentFragment on EGDSSpannableTextItem {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    inlineContent {\n      ...EGDSSpannableTextInlineContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    resource {\n      value\n    }\n    target\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    message\n    heading\n    background\n    rightIcon {\n      ...EGDSIconFragment\n    }\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    buttons {\n      ...EGDSButtonFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment EGDSSwitchFragment on EGDSStandardSwitch {\n    enabled\n    checked\n    checkedLabel\n    uncheckedLabel\n    checkedDescription\n    uncheckedDescription\n    checkedAccessibilityLabel\n    uncheckedAccessibilityLabel\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkWrapperFragment on EGDSInlineLink {\n    __typename\n    text\n    action {\n      ...UILinkActionFragment\n    }\n    size\n    disabled\n  }\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyAnchoredCurrencyDescriptionFragment on LoyaltyAnchoredCurrencyDescription {\n    balance {\n      ...EGDSStylizedTextFragment\n    }\n    subtitle {\n      ...EGDSStylizedTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyAnchoredCurrencySectionFragment on LoyaltyAnchoredCurrencySection {\n    anchoredBalance {\n      ...LoyaltyAnchoredCurrencyDescriptionFragment\n    }\n    posaBalance {\n      ...LoyaltyAnchoredCurrencyDescriptionFragment\n    }\n    transferIcon {\n      ...EGDSIconFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyStylizedTextFragment on LoyaltyStylizedText {\n    stylizedText {\n      ...EGDSStylizedTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyIconInfoOverlaySubContentFragment on LoyaltyIconInfoOverlaySubContent {\n    ...LoyaltyStylizedTextFragment\n    ...LoyaltyAnchoredCurrencySectionFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyIconInfoContentSectionFragment on LoyaltyIconInfoContentSection {\n    __typename\n    actionText\n    contents {\n      ...LoyaltyIconInfoOverlaySubContentFragment\n    }\n    heading\n    analytics {\n      eventName\n      eventVersion\n      payload\n    }\n  }\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyMembershipAnchorCurrencyLinkFragment on LoyaltyMembershipAnchorCurrencyLink {\n    __typename\n    dialog {\n      __typename\n      ...LoyaltyIconInfoContentSectionFragment\n    }\n    link {\n      __typename\n      ...EGDSInlineLinkWrapperFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment OneKeyMessagingCardSpannableTextFragment on OneKeyMessagingCardSpannableText {\n    __typename\n    contents {\n      ... on EGDSStylizedText {\n        __typename\n        text\n        textSize: size\n      }\n      ... on LoyaltyMembershipAnchorCurrencyLink {\n        __typename\n        ...LoyaltyMembershipAnchorCurrencyLinkFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment OneKeyMessagingCardFragment on OneKeyMessagingCard {\n    __typename\n    graphic {\n      __typename\n      ...EGDSGraphicFragment\n    }\n    contents: message {\n      __typename\n      ...OneKeyMessagingCardSpannableTextFragment\n    }\n    buttons {\n      __typename\n      ...EGDSButtonFragment\n    }\n    links {\n      __typename\n      ...EGDSStandardLinkFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  query OneKeyLoyaltyBannerQuery(\n    $context: ContextInput!\n    $useLoyaltyCurrency: Boolean\n    $pageLocation: PageLocation!\n    $lineOfBusiness: LineOfBusinessDomain!\n    $packageType: PackageType\n    $packageLOB: LineOfBusinessDomain\n    $marketing: MarketingInfoInput\n    $searchContext: SearchContextInput\n    $pageLocationContext: PageLocationContextInput\n  ) {\n    oneKeyLoyaltyBanner(\n      context: $context\n      useLoyaltyCurrency: $useLoyaltyCurrency\n      pageLocation: $pageLocation\n      lineOfBusiness: $lineOfBusiness\n      packageType: $packageType\n      packageLOB: $packageLOB\n      marketing: $marketing\n      searchContext: $searchContext\n      pageLocationContext: $pageLocationContext\n    ) {\n      element {\n        ... on OneKeyBurnSwitch {\n          burnSwitchGraphic: graphic {\n            ...EGDSGraphicFragment\n          }\n          switch {\n            ...EGDSSwitchFragment\n          }\n          impressionTracking {\n            ...ClientSideAnalyticsFragment\n          }\n        }\n        ... on OneKeyMessagingCard {\n          ...OneKeyMessagingCardFragment\n        }\n        ... on EGDSStandardMessagingCard {\n          ...EGDSStandardMessagingCardFragment\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
import React33 from "react";
import { gql as gql27, useQuery } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSBlockSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var __EGDSIconFragment = gql(_templateObject());
var LoyaltyEGDSIcon = function (param) {
  var className = param.className,
    theme = param.theme,
    _param_isAriaHidden = param.isAriaHidden,
    isAriaHidden = _param_isAriaHidden === void 0 ? false : _param_isAriaHidden,
    data = param.data;
  var spotlight = (data === null || data === void 0 ? void 0 : data.withBackground) ? "info" : void 0;
  var _data_title;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    className: className,
    description: isAriaHidden ? void 0 : data === null || data === void 0 ? void 0 : data.description,
    id: data === null || data === void 0 ? void 0 : data.id,
    name: data !== null ? data.id : "",
    size: (data === null || data === void 0 ? void 0 : data.size) ? EGDSIconSize[data.size] : void 0,
    title: isAriaHidden ? void 0 : (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: theme || (data === null || data === void 0 ? void 0 : data.theme) || void 0,
    spotlight: spotlight
  });
};
LoyaltyEGDSIcon.displayName = "LoyaltyEGDSIcon";
LoyaltyEGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
var __EGDSIllustrationFragment = gql2(_templateObject1());
var EGDSIllustration = function (param) {
  var data = param.data;
  return /* @__PURE__ */React2.createElement(EGDSIllustrations, {
    alt: data.description,
    url: data.link
  });
};
EGDSIllustration.displayName = "Illustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
var __EGDSMarkFragment = gql3(_templateObject2());
var LoyaltyEGDSMark = function (param) {
  var className = param.className,
    markSize = param.markSize,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React3.createElement(EGDSMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: markSize || data.markSize && EGDSMarkSize[data.markSize],
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
LoyaltyEGDSMark.displayName = "LoyaltyEGDSMark";
LoyaltyEGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
var __EGDSGraphicFragment = gql4(_templateObject3(), LoyaltyEGDSIcon.fragment, LoyaltyEGDSMark.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    markSize = param.markSize,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React4.createElement(LoyaltyEGDSIcon, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React4.createElement(LoyaltyEGDSMark, {
        className: className,
        data: data,
        markSize: markSize
      });
    case "Illustration":
      return /* @__PURE__ */React4.createElement(EGDSIllustration, {
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React22 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSCard, EGDSCardBackgroundThemes as EGDSCardBackgroundThemes2, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/client-side-analytics.ts
import { gql as gql5 } from "@apollo/client";
var ClientSideAnalyticsFragment = gql5(_templateObject4());
// ../internal/src/utils/uitk-card-mapper.ts
import { EGDSCardBackgroundThemes } from "@egds/react-core/cards";
var _obj;
var backgroundThemeEGDSCardMapper = (_obj = {}, _define_property(_obj, EGDSCardBackgroundThemes.PRIMARY, "primary"), _define_property(_obj, EGDSCardBackgroundThemes.HIGHLIGHT, "highlight"), _define_property(_obj, EGDSCardBackgroundThemes.SECONDARY, "secondary"), _define_property(_obj, EGDSCardBackgroundThemes.GLOBAL_LOYALTY_EXTRAHIGH, "global-loyalty-extra-high"), _define_property(_obj, EGDSCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD, "global-loyalty-standard"), _define_property(_obj, EGDSCardBackgroundThemes.GLOBAL_LOYALTY_LOW, "global-loyalty-low"), _define_property(_obj, EGDSCardBackgroundThemes.GLOBAL_LOYALTY_MIDDLE, "global-loyalty-middle"), _define_property(_obj, EGDSCardBackgroundThemes.GLOBAL_LOYALTY_HIGH, "global-loyalty-high"), _obj);
// ../internal/src/components/common-functional-components/internal-buttons-layout-flex-item.tsx
import React6 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
// ../internal/src/components/egds-button/egds-button.tsx
import React5 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSOverlayButton, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/hooks/use-gss-redirect-url.tsx
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { useBexApi } from "@shared-ui/bex-api-context";
var HOTWIRE = 30031;
var useGssRedirectUrl = function (baseUrl) {
  var getReturnUrlParam = function getReturnUrlParam(location2, siteId2) {
    var pathname = location2.pathname,
      search = location2.search,
      hash = location2.hash;
    var returnUrl = pathname.concat(search, hash);
    switch (siteId2) {
      case HOTWIRE:
        return "&redirectUrl=targeturl=".concat(encodeURIComponent(returnUrl), "&referrerId=wl_prod");
      default:
        return "&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
    }
  };
  var hasRedirectUrl = baseUrl.indexOf("uurl") > -1;
  var currentLocation = useLocation();
  var getCurrentLocation = function () {
    return {
      pathname: "".concat(currentLocation.pathname),
      search: "".concat(currentLocation.search),
      hash: "".concat(currentLocation.hash)
    };
  };
  var context = useBexApi().context;
  var _useState = _sliced_to_array(useState(getCurrentLocation), 2),
    location = _useState[0],
    setLocation = _useState[1];
  var siteId = context === null || context === void 0 ? void 0 : context.siteId;
  useEffect(function () {
    var handleLocationChange = function () {
      return setLocation(getCurrentLocation());
    };
    window.addEventListener("popstate", handleLocationChange);
    return function () {
      return window.removeEventListener("popstate", handleLocationChange);
    };
  }, [getCurrentLocation]);
  var authURL = "";
  if (!hasRedirectUrl) {
    authURL = baseUrl + (baseUrl.indexOf("?") !== -1 ? "" : "?") + getReturnUrlParam(location || {}, siteId);
  }
  return authURL;
};
var _obj1;
// ../internal/src/utils/link-mapper.ts
var UILinkTargetMap = (_obj1 = {}, _define_property(_obj1, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj1, "INTERNAL" /* INTERNAL */, "_self"), _obj1);
var _obj2;
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */, "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "LARGE" /* LARGE */, "large"), _obj2);
// ../internal/src/components/egds-button/button-action-helpers.ts
var getLoyaltyUILinkActionPath = function (action) {
  if (action.resource.__typename !== "HttpURI") {
    return null;
  }
  return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLoyaltyUILinkActionTarget = function (action) {
  return UILinkTargetMap[action.target];
};
// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql6(_templateObject5());
var deriveLinkProps = function (action) {
  if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
    return {};
  }
  var path = getLoyaltyUILinkActionPath(action);
  if (!path) {
    return {};
  }
  return {
    href: path,
    target: getLoyaltyUILinkActionTarget(action),
    tag: "a"
  };
};
var LoyaltyEGDSButton = function (param) {
  var className = param.className,
    dataStid = param.dataStid,
    domRef = param.domRef,
    href = param.href,
    isFullWidth = param.isFullWidth,
    onClickHandler = param.onClickHandler,
    size = param.size,
    inverse = param.inverse,
    isDisabled = param.isDisabled,
    isNoTextAllowed = param.isNoTextAllowed,
    _param_data = param.data,
    __typename = _param_data.__typename,
    accessibility = _param_data.accessibility,
    primary = _param_data.primary,
    disabled = _param_data.disabled,
    analytics = _param_data.analytics,
    action = _param_data.action,
    icon = _param_data.icon;
  var clickTracker = useClickTracker();
  var linkProps = deriveLinkProps(action);
  var _linkProps_href;
  var urlWithRedirect = useGssRedirectUrl((_linkProps_href = linkProps.href) !== null && _linkProps_href !== void 0 ? _linkProps_href : "");
  var handleOnClick = React5.useCallback(function () {
    onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  }, [onClickHandler, clickTracker, analytics]);
  if (!primary && !isNoTextAllowed) {
    return null;
  }
  if ((linkProps === null || linkProps === void 0 ? void 0 : linkProps.href) && urlWithRedirect) {
    linkProps.href = urlWithRedirect;
  }
  var buttonProps = _object_spread({
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: className,
    disabled: isDisabled || disabled,
    href: href,
    isFullWidth: isFullWidth,
    onClick: handleOnClick,
    size: size,
    domRef: domRef
  }, linkProps);
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React5.createElement(EGDSPrimaryButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid,
        inverse: inverse
      }), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React5.createElement(EGDSSecondaryButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid,
        inverse: inverse
      }), primary);
    case "UITertiaryButton":
      var _icon_title, _icon_theme;
      return /* @__PURE__ */React5.createElement(EGDSTertiaryButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid,
        inverse: inverse
      }), icon && /* @__PURE__ */React5.createElement(EGDSIcon2, {
        description: icon.description,
        id: icon.id,
        name: icon.token,
        title: (_icon_title = icon.title) !== null && _icon_title !== void 0 ? _icon_title : void 0,
        theme: (_icon_theme = icon.theme) !== null && _icon_theme !== void 0 ? _icon_theme : void 0
      }), primary);
    case "EGDSOverlayButton":
      var _icon_title1, _icon_theme1;
      return /* @__PURE__ */React5.createElement(EGDSOverlayButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid
      }), icon && /* @__PURE__ */React5.createElement(EGDSIcon2, {
        description: icon.description,
        id: icon.id,
        name: icon.token,
        title: (_icon_title1 = icon.title) !== null && _icon_title1 !== void 0 ? _icon_title1 : void 0,
        theme: (_icon_theme1 = icon.theme) !== null && _icon_theme1 !== void 0 ? _icon_theme1 : void 0
      }), primary);
    default:
      return null;
  }
};
LoyaltyEGDSButton.fragment = _Fragment;
LoyaltyEGDSButton.displayName = "LoyaltyEGDSButton";
// ../internal/src/components/common-functional-components/internal-buttons-layout-flex-item.tsx
var InternalButtonsLayoutFlexItem = function (param) {
  var buttons = param.buttons,
    dataStid = param.dataStid,
    isBgColored = param.isBgColored,
    onClickHandler = param.onClickHandler;
  return (buttons === null || buttons === void 0 ? void 0 : buttons.length) ? /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React6.createElement(EGDSSpacing, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlex, null, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (buttonData, buttonIndex) {
    return /* @__PURE__ */React6.createElement(EGDSSpacing, {
      margin: {
        inlinestart: buttonIndex === 0 ? "unset" : "two"
      },
      key: buttonIndex
    }, /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React6.createElement(LoyaltyEGDSButton, {
      data: buttonData,
      dataStid: dataStid ? "".concat(dataStid, "-").concat(buttonData.__typename, "-").concat(buttonIndex) : void 0,
      size: EGDSButtonSize.SMALL,
      inverse: isBgColored && buttonData.__typename === "UITertiaryButton",
      onClickHandler: onClickHandler(buttonIndex)
    })));
  })))) : null;
};
// ../internal/src/components/common-functional-components/internal-graphic-layout-flex-item.tsx
import React7 from "react";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
var margin = function (isBgColored) {
  return {
    small: {
      inlineend: "three"
    },
    medium: {
      inlineend: isBgColored ? "six" : "three"
    }
  };
};
var InternalGraphicLayoutFlexItem = function (param) {
  var graphic = param.graphic,
    markSize = param.markSize,
    isBgColored = param.isBgColored;
  return graphic ? /* @__PURE__ */React7.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "start"
  }, /* @__PURE__ */React7.createElement("div", null, /* @__PURE__ */React7.createElement(EGDSSpacing2, {
    margin: margin(isBgColored)
  }, /* @__PURE__ */React7.createElement("div", null, /* @__PURE__ */React7.createElement(EGDSGraphic, {
    data: graphic,
    markSize: markSize
  }))))) : null;
};
// ../internal/src/components/common-functional-components/internal-links-layout-flex-item.tsx
import React16 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React8 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var fragment = gql7(_templateObject6());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    size = param.size,
    theme = param.theme,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React8.createElement(EGDSText, {
    className: className,
    inline: inline,
    size: size,
    theme: theme
  }, text);
};
EGDSPlainText.fragment = fragment;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React9 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment2 = gql8(_templateObject7(), LoyaltyEGDSIcon.fragment);
var getHrefFromLinkAction = function (param) {
  var resource = param.resource,
    useRelativePath = param.useRelativePath;
  switch (resource.__typename) {
    case "HttpURI":
      return useRelativePath ? resource.relativePath : resource.value;
    default:
      return resource.value;
  }
};
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React9.createElement(LoyaltyEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    dataStid = param.dataStid,
    inline = param.inline,
    theme = param.theme,
    align = param.align,
    data = param.data,
    onClickHandler = param.onClickHandler;
  var _data_action = data.action,
    analytics = _data_action.analytics,
    target = _data_action.target,
    accessibility = _data_action.accessibility,
    disabled = data.disabled,
    iconPosition = data.iconPosition,
    standardLinkIcon = data.standardLinkIcon,
    size = data.size,
    text = data.text;
  var clickTracker = useClickTracker2();
  var onClick = React9.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, analytics]);
  var getPath = React9.useCallback(function () {
    return getHrefFromLinkAction(data.action);
  }, [data.action]);
  return /* @__PURE__ */React9.createElement(EGDSLink, {
    className: className,
    "data-stid": dataStid,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    theme: theme || "default",
    align: align
  }, /* @__PURE__ */React9.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React9.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React9.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React9.createElement(EGDSText2, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment2;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React10 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
// ../internal/src/utils/text-mapper.ts
var TextThemeMapper = /* @__PURE__ */function (TextThemeMapper2) {
  TextThemeMapper2["INVERSE"] = "inverse";
  TextThemeMapper2["LOYALTY"] = "loyalty";
  TextThemeMapper2["NEGATIVE"] = "negative";
  TextThemeMapper2["POSITIVE"] = "positive";
  TextThemeMapper2["PENDING"] = "default";
  return TextThemeMapper2;
}(TextThemeMapper || {});
var sizeMapper = {
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
};
var _obj3;
var textWeightMapper = (_obj3 = {}, _define_property(_obj3, "BOLD" /* BOLD */, "bold"), _define_property(_obj3, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj3, "REGULAR" /* REGULAR */, "regular"), _obj3);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment3 = gql9(_templateObject8());
var EGDSStylizedText = function (param) {
  var data = param.data,
    whiteSpace = param.whiteSpace,
    _param_useBackendTheme = param.useBackendTheme,
    useBackendTheme = _param_useBackendTheme === void 0 ? true : _param_useBackendTheme,
    align = param.align,
    inline = param.inline;
  var stylizedText = data.stylizedText,
    theme = data.theme,
    weight = data.weight,
    textSize = data.textSize;
  var themeToUse = useBackendTheme && theme ? TextThemeMapper[theme] : void 0;
  return /* @__PURE__ */React10.createElement(EGDSText3, {
    theme: themeToUse,
    align: align,
    whiteSpace: whiteSpace,
    weight: weight ? textWeightMapper[weight] : void 0,
    size: textSize ? sizeMapper[textSize] : void 0,
    inline: inline
  }, stylizedText);
};
EGDSStylizedText.fragment = fragment3;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React14, { Fragment } from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-inline-content.tsx
import React13 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
import React12 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSLink as EGDSLink3, EGDSLinkSizes } from "@egds/react-core/link";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-inline-link-wrapper/ui-link-action.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker3, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var fragment4 = gql10(_templateObject9());
var UILinkAction = function (param) {
  var children = param.children,
    data = param.data,
    onClick = param.onClick,
    size = param.size,
    disabled = param.disabled,
    isButton = param.isButton,
    inline = param.inline,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData;
  var resource = data.resource,
    analytics = data.analytics,
    accessibility = data.accessibility;
  var clickTracker = useClickTracker3();
  var track = useEgClickstream();
  var onClickCapture = React11.useCallback(function () {
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
    if ((clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: clickstreamAnalyticsData.eventName,
            event_version: clickstreamAnalyticsData.eventVersion
          }
        },
        serverPayload: clickstreamAnalyticsData.serverPayload
      });
    }
  }, [analytics, clickstreamAnalyticsData, clickTracker, track]);
  return isButton ? /* @__PURE__ */React11.createElement(EGDSLink2, {
    onClick: onClick,
    size: size,
    disabled: disabled,
    inline: inline
  }, /* @__PURE__ */React11.createElement("button", {
    type: "button",
    onClickCapture: onClickCapture,
    "aria-label": accessibility || ""
  }, children)) : /* @__PURE__ */React11.createElement("a", {
    href: resource.value,
    onClickCapture: onClickCapture,
    "aria-label": accessibility || ""
  }, children);
};
UILinkAction.fragment = fragment4;
UILinkAction.displayName = "UILinkAction";
// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
var fragment5 = gql11(_templateObject10(), UILinkAction.fragment);
var EGDSInlineLink = function (param) {
  var data = param.data,
    onClickHandler = param.onClickHandler;
  var action = data.action,
    disabled = data.disabled,
    size = data.size,
    text = data.text;
  var clickTracker = useClickTracker4();
  var onClick = React12.useCallback(function () {
    clickTracker(action.analytics.referrerId, action.analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, action.analytics]);
  return /* @__PURE__ */React12.createElement(EGDSLink3, {
    onClick: onClick,
    inline: true,
    disabled: disabled,
    size: EGDSLinkSizes[size]
  }, /* @__PURE__ */React12.createElement("a", {
    href: action.resource.value,
    target: action.target
  }, text, action.accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, action.accessibility)));
};
EGDSInlineLink.fragment = fragment5;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-inline-content.tsx
var fragment6 = gql12(_templateObject11(), EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment);
var EGDSSpannableTextInlineContent = function (param) {
  var size = param.size,
    align = param.align,
    theme = param.theme,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React13.createElement(EGDSStylizedText, {
        align: align,
        data: data,
        inline: true
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React13.createElement(EGDSPlainText, {
        data: data,
        size: size,
        theme: theme,
        inline: true
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React13.createElement(EGDSStandardLink, {
        data: data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React13.createElement(EGDSInlineLink, {
        data: data
      });
    default:
      return null;
  }
};
EGDSSpannableTextInlineContent.fragment = fragment6;
EGDSSpannableTextInlineContent.displayName = "EGDSSpannableTextInlineContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment7 = gql13(_templateObject12(), EGDSSpannableTextInlineContent.fragment);
var EGDSSpannableText = function (param) {
  var align = param.align,
    data = param.data,
    size = param.size,
    theme = param.theme;
  var _data_inlineContent;
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
    return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React14.createElement(Fragment, {
        key: "inline-content-".concat(index)
      }, /* @__PURE__ */React14.createElement(EGDSSpannableTextInlineContent, {
        align: align,
        data: item,
        size: size,
        theme: theme
      }), " ");
    }));
  }
  return null;
};
EGDSSpannableText.fragment = fragment7;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
import React15 from "react";
import { gql as gql14 } from "@apollo/client";
var fragment8 = gql14(_templateObject13(), EGDSPlainText.fragment, EGDSStandardLink.fragment);
var LoyaltyEGDSText = function (param) {
  var data = param.data,
    standardLinkProps = param.standardLinkProps,
    plainTextProps = param.plainTextProps;
  var __typename = data.__typename;
  switch (__typename) {
    case "EGDSStandardLink":
      return /* @__PURE__ */React15.createElement(EGDSStandardLink, _object_spread({
        data: data
      }, standardLinkProps));
    case "EGDSPlainText":
      return /* @__PURE__ */React15.createElement(EGDSPlainText, _object_spread({
        data: data
      }, plainTextProps));
    default:
      return null;
  }
};
LoyaltyEGDSText.fragment = fragment8;
LoyaltyEGDSText.displayName = "LoyaltyEGDSText";
// ../internal/src/components/common-functional-components/internal-links-layout-flex-item.tsx
var InternalLinksLayoutFlexItem = function (param) {
  var links = param.links,
    dataStid = param.dataStid,
    isBgColored = param.isBgColored,
    onClickHandler = param.onClickHandler;
  return (links === null || links === void 0 ? void 0 : links.length) ? /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React16.createElement(EGDSSpacing3, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlex2, null, links === null || links === void 0 ? void 0 : links.map(function (linkData, linkIndex) {
    return /* @__PURE__ */React16.createElement(EGDSSpacing3, {
      margin: {
        inlinestart: linkIndex === 0 ? "unset" : "two"
      },
      key: linkIndex
    }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSStandardLink, {
      data: linkData,
      dataStid: dataStid ? "".concat(dataStid, "-").concat(linkData.__typename, "-").concat(linkIndex) : void 0,
      theme: isBgColored ? "inverse" : "default",
      onClickHandler: onClickHandler(linkIndex)
    }))));
  })))) : null;
};
// ../internal/src/components/common-functional-components/internal-message-or-header-layout-flex-item.tsx
import React17 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText4 } from "@egds/react-core/text";
var LocalHeader = function (param) {
  var heading = param.heading,
    headingTag = param.headingTag,
    isBgColored = param.isBgColored;
  return heading ? /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React17.createElement(EGDSHeading, {
    tag: headingTag,
    className: isBgColored ? "uitk-text-inverse-theme" : ""
  }, heading)) : null;
};
var LocalMessageAsHeaderOrText = function (param) {
  var heading = param.heading,
    headingTag = param.headingTag,
    message = param.message,
    isBgColored = param.isBgColored,
    shouldIgnoreHeading = param.shouldIgnoreHeading;
  if (heading) {
    return /* @__PURE__ */React17.createElement(EGDSSpacing4, {
      margin: {
        blockstart: "".concat(heading ? "half" : "unset")
      }
    }, /* @__PURE__ */React17.createElement(EGDSText4, {
      theme: isBgColored ? "inverse" : "default"
    }, message));
  }
  if (shouldIgnoreHeading) {
    return /* @__PURE__ */React17.createElement(EGDSText4, {
      className: isBgColored ? "uitk-text-inverse-theme" : "",
      weight: "medium",
      size: 400
    }, message);
  }
  return /* @__PURE__ */React17.createElement(EGDSHeading, {
    tag: headingTag,
    className: isBgColored ? "uitk-text-inverse-theme" : ""
  }, message);
};
var LocalMessage = function (props) {
  return props.message ? /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React17.createElement(LocalMessageAsHeaderOrText, _object_spread({}, props))) : null;
};
var InternalMessageOrHeaderLayoutFlexItem = function (props) {
  return /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem4, {
    grow: 1,
    minWidth: "88x"
  }, /* @__PURE__ */React17.createElement(EGDSLayoutFlex3, {
    direction: "column"
  }, /* @__PURE__ */React17.createElement(EGDSSpacing4, {
    padding: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React17.createElement("div", null, /* @__PURE__ */React17.createElement(LocalHeader, _object_spread({}, props)), /* @__PURE__ */React17.createElement(LocalMessage, _object_spread({}, props))))));
};
// ../internal/src/components/common-functional-components/internal-right-icon-layout-flex-item.tsx
import React18 from "react";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
var InternalRightIconLayoutFlexItem = function (param) {
  var rightIcon = param.rightIcon;
  return rightIcon ? /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React18.createElement("div", {
    "data-stid": "chevron-right"
  }, /* @__PURE__ */React18.createElement(LoyaltyEGDSIcon, {
    data: rightIcon,
    isAriaHidden: true
  }))) : null;
};
// ../internal/src/components/egds-ui-link-action/egds-ui-link-action.tsx
import React19 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSCardLink } from "@egds/react-core/cards";
import { useClickTracker as useClickTracker5, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var __fragment = gql15(_templateObject14());
var EGDSUICardLinkAction = function (param) {
  var data = param.data,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData;
  var resource = data.resource,
    target = data.target,
    analytics = data.analytics,
    accessibility = data.accessibility;
  var href = resource.value;
  var navigationTarget = target === "INTERNAL" /* INTERNAL */ ? "_self" : "_blank";
  var track = useEgClickstream2();
  var clickTracker = useClickTracker5();
  var onClickCapture = React19.useCallback(function () {
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
    if ((clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName,
            event_version: clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion
          }
        },
        serverPayload: clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload
      });
    }
  }, [analytics, clickTracker, track, clickstreamAnalyticsData]);
  return /* @__PURE__ */React19.createElement(EGDSCardLink, null, /* @__PURE__ */React19.createElement("a", {
    href: href,
    target: navigationTarget,
    rel: "noopener",
    onClickCapture: onClickCapture,
    "aria-label": accessibility || ""
  }, accessibility));
};
EGDSUICardLinkAction.fragment = __fragment;
EGDSUICardLinkAction.displayName = "EGDSUICardLinkAction";
// ../internal/src/components/loyalty-click-stream-tracker-wrapper/loyalty-click-stream-tracker-wrapper.tsx
import React20 from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var LoyaltyClickstreamImpressionTrackerWrapper = function (param) {
  var trackingProps = param.trackingProps,
    children = param.children;
  return trackingProps ? /* @__PURE__ */React20.createElement(EgClickstreamImpressionTracker, {
    eventData: trackingProps
  }, children) : /* @__PURE__ */React20.createElement(React20.Fragment, null, children);
};
// ../internal/src/components/loyalty-intersection-tracker-wrapper/loyalty-intersection-tracker-wrapper.tsx
import React21 from "react";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var defaults = {
  intersectionOptions: {
    threshold: 0.5
  }
};
var LoyaltyIntersectionTrackerWrapper = function (param) {
  var trackingProps = param.trackingProps,
    children = param.children;
  return trackingProps ? /* @__PURE__ */React21.createElement(IntersectionTracker, _object_spread({}, defaults, trackingProps), children) : /* @__PURE__ */React21.createElement(React21.Fragment, null, children);
};
// ../internal/src/components/egds-standard-messaging-card/egds-standard-messaging-card.tsx
var fragment9 = gql16(_templateObject15(), LoyaltyEGDSIcon.fragment, EGDSGraphic.fragment, EGDSStandardLink.fragment, LoyaltyEGDSButton.fragment, ClientSideAnalyticsFragment);
var EGDSStandardMessagingCard = function (param) {
  var data = param.data,
    markSize = param.markSize,
    className = param.className,
    dataStid = param.dataStid,
    actionProps = param.actionProps,
    headingTag = param.headingTag,
    _param_showBorder = param.showBorder,
    showBorder = _param_showBorder === void 0 ? true : _param_showBorder,
    customClickStreamAnalyticsData = param.customClickStreamAnalyticsData,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData,
    shouldIgnoreHeading = param.shouldIgnoreHeading;
  var message = data.message,
    _data_background = data.background,
    background = _data_background === void 0 ? EGDSCardBackgroundThemes2.PRIMARY : _data_background,
    links = data.links,
    graphic = data.graphic,
    heading = data.heading,
    rightIcon = data.rightIcon,
    buttons = data.buttons,
    impressionTracking = data.impressionTracking;
  var cardPadding = background === EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_STANDARD ? {
    inline: "three",
    block: "three"
  } : {
    inline: "one",
    block: "one"
  };
  var isBgColored = background !== null && background !== EGDSCardBackgroundThemes2.PRIMARY && background !== EGDSCardBackgroundThemes2.SECONDARY;
  var backgroundTheme = background && backgroundThemeEGDSCardMapper[background];
  var trackClickStream = useEgClickstream3();
  var onClickHandler = function (clickstreamData) {
    return function (index) {
      var egClickstreamData = clickstreamData === null || clickstreamData === void 0 ? void 0 : clickstreamData[index];
      return egClickstreamData ? function () {
        return trackClickStream(egClickstreamData);
      } : void 0;
    };
  };
  return /* @__PURE__ */React22.createElement(LoyaltyIntersectionTrackerWrapper, {
    trackingProps: impressionTracking
  }, /* @__PURE__ */React22.createElement(LoyaltyClickstreamImpressionTrackerWrapper, {
    trackingProps: customClickStreamAnalyticsData === null || customClickStreamAnalyticsData === void 0 ? void 0 : customClickStreamAnalyticsData.impressionTracking
  }, /* @__PURE__ */React22.createElement(EGDSCard, {
    className: className,
    border: showBorder,
    padded: true,
    backgroundTheme: backgroundTheme
  }, /* @__PURE__ */React22.createElement(EGDSCardContentSection, {
    "data-stid": dataStid
  }, /* @__PURE__ */React22.createElement(EGDSSpacing5, {
    padding: cardPadding
  }, /* @__PURE__ */React22.createElement(EGDSLayoutFlex4, {
    alignItems: "center"
  }, /* @__PURE__ */React22.createElement(InternalGraphicLayoutFlexItem, {
    graphic: graphic,
    isBgColored: isBgColored,
    markSize: markSize
  }), /* @__PURE__ */React22.createElement(EGDSLayoutFlexItem6, {
    grow: 1
  }, /* @__PURE__ */React22.createElement(EGDSCardContentSection, {
    padded: false
  }, /* @__PURE__ */React22.createElement(EGDSLayoutFlex4, {
    direction: "row",
    alignItems: "center",
    justifyContent: "space-between",
    space: "two",
    wrap: rightIcon ? "nowrap" : "wrap"
  }, /* @__PURE__ */React22.createElement(InternalMessageOrHeaderLayoutFlexItem, {
    heading: heading,
    headingTag: headingTag,
    isBgColored: isBgColored,
    message: message,
    shouldIgnoreHeading: shouldIgnoreHeading
  }), /* @__PURE__ */React22.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React22.createElement(EGDSLayoutFlex4, {
    alignItems: "center",
    space: "four",
    justifyContent: "end"
  }, /* @__PURE__ */React22.createElement(InternalButtonsLayoutFlexItem, {
    buttons: buttons,
    dataStid: dataStid,
    isBgColored: isBgColored,
    onClickHandler: onClickHandler(customClickStreamAnalyticsData === null || customClickStreamAnalyticsData === void 0 ? void 0 : customClickStreamAnalyticsData.buttons)
  }), /* @__PURE__ */React22.createElement(InternalLinksLayoutFlexItem, {
    links: links,
    dataStid: dataStid,
    isBgColored: isBgColored,
    onClickHandler: onClickHandler(customClickStreamAnalyticsData === null || customClickStreamAnalyticsData === void 0 ? void 0 : customClickStreamAnalyticsData.links)
  }))), /* @__PURE__ */React22.createElement(InternalRightIconLayoutFlexItem, {
    rightIcon: rightIcon
  })))))), actionProps && /* @__PURE__ */React22.createElement(EGDSUICardLinkAction, {
    data: actionProps,
    clickstreamAnalyticsData: clickstreamAnalyticsData
  })))));
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment9;
// ../internal/src/components/egds-switch/egds-switch.tsx
import React23, { useEffect as useEffect2 } from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSSwitch } from "@egds/react-core/switch";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var fragment10 = gql17(_templateObject16());
var LoyaltyEGDSSwitch = function (param) {
  var switchHandler = param.switchHandler,
    id = param.id,
    switchPosition = param.switchPosition,
    weight = param.weight,
    data = param.data,
    onUpdate = param.onUpdate;
  var enabled = data.enabled,
    checked = data.checked,
    checkedLabel = data.checkedLabel,
    uncheckedLabel = data.uncheckedLabel,
    checkedAnalytics = data.checkedAnalytics,
    uncheckedAnalytics = data.uncheckedAnalytics,
    checkedDescription = data.checkedDescription,
    uncheckedDescription = data.uncheckedDescription,
    checkedAccessibilityLabel = data.checkedAccessibilityLabel,
    uncheckedAccessibilityLabel = data.uncheckedAccessibilityLabel;
  var _React23_useState = _sliced_to_array(React23.useState(checked), 2),
    isChecked = _React23_useState[0],
    setIsChecked = _React23_useState[1];
  useEffect2(function () {
    setIsChecked(checked);
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(setIsChecked);
  }, [checked, onUpdate]);
  var clickTracker = useClickTracker6();
  var handleSwitch = function () {
    setIsChecked(!isChecked);
    switchHandler(!isChecked);
    if (checkedAnalytics && !isChecked) {
      clickTracker(checkedAnalytics.referrerId, checkedAnalytics.linkName);
    } else if (uncheckedAnalytics && isChecked) {
      clickTracker(uncheckedAnalytics.referrerId, uncheckedAnalytics.linkName);
    }
  };
  var label = isChecked ? checkedLabel : uncheckedLabel;
  var a11yLabel = isChecked ? checkedAccessibilityLabel : uncheckedAccessibilityLabel;
  var description = isChecked ? checkedDescription : uncheckedDescription;
  var _ref;
  return /* @__PURE__ */React23.createElement(EGDSSwitch, {
    id: id,
    checked: isChecked,
    onChange: handleSwitch,
    switchPosition: switchPosition || "trailing",
    disabled: !enabled,
    a11yLabel: (_ref = a11yLabel !== null && a11yLabel !== void 0 ? a11yLabel : label) !== null && _ref !== void 0 ? _ref : void 0,
    description: description !== null && description !== void 0 ? description : void 0
  }, /* @__PURE__ */React23.createElement(EGDSText5, {
    weight: weight || "medium",
    size: 400
  }, label !== null && label !== void 0 ? label : ""));
};
LoyaltyEGDSSwitch.fragment = fragment10;
LoyaltyEGDSSwitch.displayName = "LoyaltyEGDSSwitch";
// ../internal/src/components/one-key-messaging-card/one-key-messaging-card.tsx
import React32 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSCard as EGDSCard2, EGDSCardBackgroundThemes as EGDSCardBackgroundThemes3, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { useEgClickstream as useEgClickstream6 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/one-key-messaging-card-spannable-text/one-key-messaging-card-spannable-text.tsx
import React31 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
// ../internal/src/components/loyalty-membership-anchor-currency-link/loyalty-membership-anchor-currency-link.tsx
import React30 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSDialog, EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-inline-link-wrapper/egds-inline-link-wrapper.tsx
import React24 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
var fragment11 = gql18(_templateObject17(), UILinkAction.fragment);
var EGDSInlineLinkWrapper = function (param) {
  var data = param.data,
    onClick = param.onClick,
    isButton = param.isButton,
    inline = param.inline,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData,
    children = param.children;
  return /* @__PURE__ */React24.createElement(UILinkAction, {
    data: data.action,
    onClick: onClick,
    isButton: isButton,
    inline: inline,
    clickstreamAnalyticsData: clickstreamAnalyticsData
  }, data.text ? /* @__PURE__ */React24.createElement(EGDSHeading2, null, data.text) : children);
};
EGDSInlineLinkWrapper.fragment = fragment11;
EGDSInlineLinkWrapper.displayName = "EGDSInlineLinkWrapper";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-info-content-section.tsx
import React29, { useEffect as useEffect3 } from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/loyalty-icon-info-overlay-subcontent/loyalty-icon-info-overlay-subcontent.tsx
import React28 from "react";
import { gql as gql22 } from "@apollo/client";
// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-section.tsx
import React26 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-description.tsx
import React25 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
var fragment12 = gql19(_templateObject18(), EGDSStylizedText.fragment);
var LoyaltyAnchoredCurrencyDescription = function (param) {
  var data = param.data;
  var balance = data.balance,
    subtitle = data.subtitle;
  return /* @__PURE__ */React25.createElement(EGDSLayoutFlex5, {
    alignItems: "center",
    direction: "column"
  }, /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React25.createElement(EGDSStylizedText, {
    data: balance
  })), /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem7, {
    maxWidth: "37x"
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSStylizedText, {
    align: "center",
    data: subtitle
  }))));
};
LoyaltyAnchoredCurrencyDescription.fragment = fragment12;
LoyaltyAnchoredCurrencyDescription.displayName = "LoyaltyAnchoredCurrencyDescription";
// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-section.tsx
var fragment13 = gql20(_templateObject19(), LoyaltyAnchoredCurrencyDescription.fragment, LoyaltyEGDSIcon.fragment);
var LoyaltyAnchoredCurrencySection = function (param) {
  var data = param.data;
  var anchoredBalance = data.anchoredBalance,
    posaBalance = data.posaBalance,
    transferIcon = data.transferIcon;
  return /* @__PURE__ */React26.createElement(EGDSLayoutFlex6, {
    space: "two"
  }, /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React26.createElement(LoyaltyAnchoredCurrencyDescription, {
    data: posaBalance
  })), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React26.createElement(LoyaltyEGDSIcon, {
    data: transferIcon
  })), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React26.createElement(LoyaltyAnchoredCurrencyDescription, {
    data: anchoredBalance
  })));
};
LoyaltyAnchoredCurrencySection.fragment = fragment13;
LoyaltyAnchoredCurrencySection.displayName = "LoyaltyAnchoredCurrencySection";
// ../internal/src/components/loyalty-stylized-text/loyalty-stylized-text.tsx
import React27 from "react";
import { gql as gql21 } from "@apollo/client";
var fragment14 = gql21(_templateObject20(), EGDSStylizedText.fragment);
var LoyaltyStylizedText = function (param) {
  var data = param.data,
    stylizedTextProps = param.stylizedTextProps;
  var stylizedText = data.stylizedText;
  return /* @__PURE__ */React27.createElement(EGDSStylizedText, _object_spread({
    data: stylizedText
  }, stylizedTextProps));
};
LoyaltyStylizedText.fragment = fragment14;
LoyaltyStylizedText.displayName = "LoyaltyStylizedText";
// ../internal/src/components/loyalty-icon-info-overlay-subcontent/loyalty-icon-info-overlay-subcontent.tsx
var fragment15 = gql22(_templateObject21(), LoyaltyStylizedText.fragment, LoyaltyAnchoredCurrencySection.fragment);
var LoyaltyIconInfoOverlaySubContent = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "LoyaltyStylizedText":
      return /* @__PURE__ */React28.createElement(LoyaltyStylizedText, {
        data: data,
        stylizedTextProps: {
          align: "center"
        }
      });
    case "LoyaltyAnchoredCurrencySection":
      return /* @__PURE__ */React28.createElement(LoyaltyAnchoredCurrencySection, {
        data: data
      });
    default:
      return null;
  }
};
LoyaltyIconInfoOverlaySubContent.fragment = fragment15;
LoyaltyIconInfoOverlaySubContent.displayName = "LoyaltyIconInfoOverlaySubContent";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-info-content-section.tsx
var fragment16 = gql23(_templateObject22(), LoyaltyIconInfoOverlaySubContent.fragment);
var LoyaltyIconInfoContentSection = function (param) {
  var data = param.data,
    onClick = param.onClick;
  var actionText = data.actionText,
    contents = data.contents,
    heading = data.heading,
    analytics = data.analytics;
  var track = useEgClickstream4();
  useEffect3(function () {
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.payload) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventName) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: analytics.eventName,
            event_version: analytics.eventVersion
          }
        },
        serverPayload: analytics.payload
      });
    }
  }, []);
  return /* @__PURE__ */React29.createElement(EGDSLayoutFlex7, {
    direction: "column",
    space: "four"
  }, /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */React29.createElement(EGDSHeading3, {
    align: "center"
  }, heading)), contents === null || contents === void 0 ? void 0 : contents.map(function (item, index) {
    return /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem9, {
      key: index,
      alignSelf: "center"
    }, /* @__PURE__ */React29.createElement("div", null, /* @__PURE__ */React29.createElement(LoyaltyIconInfoOverlaySubContent, {
      data: item
    })));
  }), /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */React29.createElement(EGDSTertiaryButton2, {
    onClick: onClick
  }, actionText)));
};
LoyaltyIconInfoContentSection.fragment = fragment16;
LoyaltyIconInfoContentSection.displayName = "LoyaltyIconInfoContentSection";
// ../internal/src/components/loyalty-membership-anchor-currency-link/loyalty-membership-anchor-currency-link.tsx
var fragment17 = gql24(_templateObject23(), LoyaltyIconInfoContentSection.fragment, EGDSInlineLinkWrapper.fragment);
var LoyaltyMembershipAnchorCurrencyLink = function (param) {
  var _param_data = param.data,
    link = _param_data.link,
    dialog = _param_data.dialog;
  var dialogKey = React30.useMemo(function () {
    return "one-key-msg-dialog-".concat(Math.random().toString(36).slice(2, 5));
  }, []);
  var _useDialog = _sliced_to_array(useDialog(dialogKey), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var openDialog = dialogActions.openDialog,
    closeDialog = dialogActions.closeDialog;
  var analytics = dialog.analytics;
  var track = useEgClickstream5();
  var handleClickOpen = React30.useCallback(function () {
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.payload) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventName) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: analytics.eventName,
            event_version: analytics.eventVersion
          }
        },
        serverPayload: analytics.payload
      });
    }
    openDialog();
  }, [track, analytics, openDialog]);
  var handleCloseDialog = React30.useCallback(function () {
    closeDialog();
  }, [closeDialog]);
  return /* @__PURE__ */React30.createElement(React30.Fragment, null, /* @__PURE__ */React30.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React30.createElement(DialogComponent, null, /* @__PURE__ */React30.createElement(EGDSDialog, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true
  }, /* @__PURE__ */React30.createElement(EGDSDialogContent, {
    key: dialogKey
  }, /* @__PURE__ */React30.createElement(LoyaltyIconInfoContentSection, {
    data: dialog,
    onClick: handleCloseDialog
  }))))), /* @__PURE__ */React30.createElement(EGDSInlineLinkWrapper, {
    data: link,
    onClick: handleClickOpen,
    isButton: true,
    inline: true
  }));
};
LoyaltyMembershipAnchorCurrencyLink.fragment = fragment17;
LoyaltyMembershipAnchorCurrencyLink.displayName = "LoyaltyMembershipAnchorCurrencyLink";
// ../internal/src/components/one-key-messaging-card-spannable-text/one-key-messaging-card-spannable-text.tsx
var fragment18 = gql25(_templateObject24(), EGDSStylizedText.fragment, LoyaltyMembershipAnchorCurrencyLink.fragment);
var TernaryConditionalComponent = function (param) {
  var condition = param.condition,
    thenChildren = param.thenChildren,
    elseChildren = param.children;
  return condition ? thenChildren : elseChildren;
};
var SpannableTextMapFn = function (props, index) {
  return /* @__PURE__ */React31.createElement("span", {
    key: "SpannableText-".concat(index)
  }, /* @__PURE__ */React31.createElement(TernaryConditionalComponent, {
    condition: props.__typename === "EGDSStylizedText",
    thenChildren: props.text
  }, "\xA0", /* @__PURE__ */React31.createElement(LoyaltyMembershipAnchorCurrencyLink, {
    data: props
  }), "\xA0"));
};
var mapSize = function (content) {
  return (content === null || content === void 0 ? void 0 : content.textSize) ? sizeMapper[content.textSize] : void 0;
};
var OneKeyMessagingCardSpannableText = function (param) {
  var contents = param.data.contents;
  var _contents_;
  return ((_contents_ = contents[0]) === null || _contents_ === void 0 ? void 0 : _contents_.__typename) === "EGDSStylizedText" ? /* @__PURE__ */React31.createElement(EGDSHeading4, {
    size: mapSize(contents[0])
  }, contents.map(SpannableTextMapFn)) : null;
};
SpannableTextMapFn.displayName = "SpannableTextMapFn";
OneKeyMessagingCardSpannableText.displayName = "OneKeyMessagingCardSpannableText";
OneKeyMessagingCardSpannableText.fragment = fragment18;
// ../internal/src/components/one-key-messaging-card/one-key-messaging-card.tsx
var fragment19 = gql26(_templateObject25(), LoyaltyEGDSIcon.fragment, OneKeyMessagingCardSpannableText.fragment, ClientSideAnalyticsFragment);
var OneKeyMessagingCard = function (param) {
  var _param_data = param.data,
    graphic = _param_data.graphic,
    buttons = _param_data.buttons,
    links = _param_data.links,
    contents = _param_data.contents,
    impressionTracking = _param_data.impressionTracking,
    actionProps = param.actionProps,
    className = param.className,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData,
    customClickStreamAnalyticsData = param.customClickStreamAnalyticsData,
    dataStid = param.dataStid,
    markSize = param.markSize,
    _param_showBorder = param.showBorder,
    showBorder = _param_showBorder === void 0 ? true : _param_showBorder;
  var trackClickStream = useEgClickstream6();
  var onClickHandler = function (clickstreamData) {
    return function (index) {
      var egClickstreamData = clickstreamData === null || clickstreamData === void 0 ? void 0 : clickstreamData[index];
      return egClickstreamData ? function () {
        return trackClickStream(egClickstreamData);
      } : void 0;
    };
  };
  var backgroundTheme = backgroundThemeEGDSCardMapper[EGDSCardBackgroundThemes3.PRIMARY];
  return /* @__PURE__ */React32.createElement(LoyaltyIntersectionTrackerWrapper, {
    trackingProps: impressionTracking
  }, /* @__PURE__ */React32.createElement(LoyaltyClickstreamImpressionTrackerWrapper, {
    trackingProps: customClickStreamAnalyticsData === null || customClickStreamAnalyticsData === void 0 ? void 0 : customClickStreamAnalyticsData.impressionTracking
  }, /* @__PURE__ */React32.createElement(EGDSCard2, {
    className: className,
    border: showBorder,
    padded: true,
    backgroundTheme: backgroundTheme
  }, /* @__PURE__ */React32.createElement(EGDSCardContentSection2, {
    "data-stid": dataStid
  }, /* @__PURE__ */React32.createElement(EGDSSpacing6, {
    padding: {
      inline: "one",
      block: "one"
    }
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlex8, {
    alignItems: "center"
  }, /* @__PURE__ */React32.createElement(InternalGraphicLayoutFlexItem, {
    graphic: graphic,
    markSize: markSize,
    isBgColored: true
  }), /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem10, {
    grow: 1
  }, /* @__PURE__ */React32.createElement(EGDSCardContentSection2, {
    padded: false
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlex8, {
    direction: "row",
    alignItems: "center",
    justifyContent: "space-between",
    space: "two",
    wrap: "wrap"
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem10, {
    grow: 1
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlex8, {
    space: "one",
    wrap: "wrap"
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React32.createElement(OneKeyMessagingCardSpannableText, {
    data: contents
  })))), /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React32.createElement(EGDSLayoutFlex8, {
    alignItems: "center",
    justifyContent: "end",
    space: "four"
  }, /* @__PURE__ */React32.createElement(InternalButtonsLayoutFlexItem, {
    buttons: buttons,
    dataStid: dataStid,
    onClickHandler: onClickHandler(customClickStreamAnalyticsData === null || customClickStreamAnalyticsData === void 0 ? void 0 : customClickStreamAnalyticsData.buttons)
  }), /* @__PURE__ */React32.createElement(InternalLinksLayoutFlexItem, {
    links: links,
    dataStid: dataStid,
    onClickHandler: onClickHandler(customClickStreamAnalyticsData === null || customClickStreamAnalyticsData === void 0 ? void 0 : customClickStreamAnalyticsData.buttons)
  })))))))), actionProps && /* @__PURE__ */React32.createElement(EGDSUICardLinkAction, {
    data: actionProps,
    clickstreamAnalyticsData: clickstreamAnalyticsData
  })))));
};
OneKeyMessagingCard.displayName = "OneKeyMessagingCard";
OneKeyMessagingCard.fragment = fragment19;
// src/components/one-key-banner/one-key-banner.tsx
import { OneKeyBurnSwitch } from "@shared-ui/retail-loyalty-one-key-burn-switch";
import { ProductType, useProductType } from "@shared-ui/retail-product-type-providers";
// src/__generated__/types.ts
var LineOfBusinessDomain = /* @__PURE__ */function (LineOfBusinessDomain2) {
  LineOfBusinessDomain2["ACTIVITIES"] = "ACTIVITIES";
  LineOfBusinessDomain2["CAR"] = "CAR";
  LineOfBusinessDomain2["CRUISES"] = "CRUISES";
  LineOfBusinessDomain2["FLIGHT"] = "FLIGHT";
  LineOfBusinessDomain2["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  LineOfBusinessDomain2["LODGING"] = "LODGING";
  LineOfBusinessDomain2["PACKAGES"] = "PACKAGES";
  LineOfBusinessDomain2["RAILS"] = "RAILS";
  LineOfBusinessDomain2["UNCLASSIFIED"] = "UNCLASSIFIED";
  return LineOfBusinessDomain2;
}(LineOfBusinessDomain || {});
var PackageType = /* @__PURE__ */function (PackageType2) {
  PackageType2["FLIGHT_CAR"] = "FLIGHT_CAR";
  PackageType2["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
  PackageType2["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
  PackageType2["HOTEL_ACTIVITY"] = "HOTEL_ACTIVITY";
  PackageType2["HOTEL_CAR"] = "HOTEL_CAR";
  return PackageType2;
}(PackageType || {});
var PageLocation = /* @__PURE__ */function (PageLocation2) {
  PageLocation2["CFAR_DETAILS"] = "CFAR_DETAILS";
  PageLocation2["CHECKOUT"] = "CHECKOUT";
  PageLocation2["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
  PageLocation2["CONFIRMATION"] = "CONFIRMATION";
  PageLocation2["DETAILS"] = "DETAILS";
  PageLocation2["ENTRY"] = "ENTRY";
  PageLocation2["FEATURES"] = "FEATURES";
  PageLocation2["INSURANCE_DETAILS"] = "INSURANCE_DETAILS";
  PageLocation2["ITINERARY"] = "ITINERARY";
  PageLocation2["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  PageLocation2["POST_BOOKING"] = "POST_BOOKING";
  PageLocation2["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  PageLocation2["SYSTEM"] = "SYSTEM";
  PageLocation2["USER"] = "USER";
  return PageLocation2;
}(PageLocation || {});
// src/components/one-key-banner/one-key-banner.tsx
var __Query = gql27(_templateObject26(), ClientSideAnalyticsFragment, EGDSGraphic.fragment, LoyaltyEGDSSwitch.fragment, OneKeyMessagingCard.fragment, EGDSStandardMessagingCard.fragment);
var _obj4;
var productTypeMap = (_obj4 = {}, _define_property(_obj4, ProductType.Cruise, "CRUISES" /* CRUISES */), _define_property(_obj4, ProductType.GroundTransportation, "GROUNDTRANSFERS" /* GROUNDTRANSFERS */), _define_property(_obj4, ProductType.Lodging, "LODGING" /* LODGING */), _define_property(_obj4, ProductType.Activities, "ACTIVITIES" /* ACTIVITIES */), _define_property(_obj4, ProductType.Cars, "CAR" /* CAR */), _define_property(_obj4, ProductType.Unclassified, "UNCLASSIFIED" /* UNCLASSIFIED */), _obj4);
var OneKeyBanner = function (props) {
  var _oneKeyData_oneKeyLoyaltyBanner_element, _oneKeyData_oneKeyLoyaltyBanner;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    switchHandler = props.switchHandler,
    _props_markSize = props.markSize,
    markSize = _props_markSize === void 0 ? 11 : _props_markSize,
    className = props.className,
    showBorder = props.showBorder,
    shouldDisableOneKeyMessagingCard = props.shouldDisableOneKeyMessagingCard,
    spacing = props.spacing;
  var context = useBexApi2().context;
  var productType = useProductType();
  var lineOfBusiness = inputs.lineOfBusiness;
  if (inputs.packageType) {
    lineOfBusiness = "PACKAGES" /* PACKAGES */;
  } else if (inputs.lineOfBusiness === "LODGING" /* LODGING */) {
    lineOfBusiness = productTypeMap[productType || ProductType.Lodging];
  }
  var variables = _object_spread_props(_object_spread({}, inputs), {
    lineOfBusiness: lineOfBusiness,
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    previousData = _useQuery.previousData;
  var oneKeyData = loading ? previousData : data;
  if (!data && !previousData && loading) {
    return /* @__PURE__ */React33.createElement(EGDSSpacing7, _object_spread({}, spacing), /* @__PURE__ */React33.createElement(EGDSLayoutGrid, {
      columns: 1,
      rows: {
        small: ["128px"],
        medium: ["92px"]
      }
    }, /* @__PURE__ */React33.createElement(EGDSLayoutPosition, {
      type: "relative"
    }, /* @__PURE__ */React33.createElement(EGDSLayoutGridItem, {
      colSpan: 1
    }, /* @__PURE__ */React33.createElement(EGDSBlockSkeleton, {
      type: "rounded"
    })))));
  }
  if (error || !oneKeyData) {
    return null;
  }
  switch ((_oneKeyData_oneKeyLoyaltyBanner = oneKeyData.oneKeyLoyaltyBanner) === null || _oneKeyData_oneKeyLoyaltyBanner === void 0 ? void 0 : (_oneKeyData_oneKeyLoyaltyBanner_element = _oneKeyData_oneKeyLoyaltyBanner.element) === null || _oneKeyData_oneKeyLoyaltyBanner_element === void 0 ? void 0 : _oneKeyData_oneKeyLoyaltyBanner_element.__typename) {
    case "OneKeyBurnSwitch":
      {
        return /* @__PURE__ */React33.createElement(OneKeyBurnSwitch, {
          className: className,
          data: oneKeyData.oneKeyLoyaltyBanner.element,
          handler: switchHandler,
          markSize: markSize
        });
      }
    case "EGDSStandardMessagingCard":
      {
        if (shouldDisableOneKeyMessagingCard) {
          return null;
        }
        return /* @__PURE__ */React33.createElement(EGDSStandardMessagingCard, {
          className: className,
          dataStid: "one-key-message-card",
          data: oneKeyData.oneKeyLoyaltyBanner.element,
          headingTag: "h2",
          markSize: markSize,
          showBorder: showBorder
        });
      }
    case "OneKeyMessagingCard":
      {
        if (shouldDisableOneKeyMessagingCard) {
          return null;
        }
        return /* @__PURE__ */React33.createElement(OneKeyMessagingCard, {
          className: className,
          data: oneKeyData.oneKeyLoyaltyBanner.element,
          dataStid: "one-key-messaging-card",
          markSize: markSize,
          showBorder: showBorder
        });
      }
    default:
      {
        return null;
      }
  }
};
OneKeyBanner.displayName = "sharedui-OneKeyBanner";
export { LineOfBusinessDomain, OneKeyBanner, PackageType, PageLocation };